import React from 'react';
import Maps from '../../elements/Maps';
import { Modal , Group } from '@mantine/core';
import styles from './styles.scoped.css';
import PropTypes from 'prop-types';
import Button from '../../elements/Button';
import IconClose from '../../icons/IconClose';

const ModalMap = ({ showMap, setShowMap, centerPoint }) => {
  return(
    <Modal
      centered
      onClose={() => setShowMap(false)}
      opened={showMap}
      size={'xl'} title="Titik Koordinat">
      <Group position="apart">
        <Button
          className={styles.buttonClose}
          onClick={() => setShowMap(false)}>
          <IconClose style={{ fill: '#CCCCCC' }}/>
        </Button>
      </Group>
      <div style={{ height: '300px' }}>
        <Maps centerPoint={centerPoint} />
      </div>
    </Modal>
  );
};

export default ModalMap;

ModalMap.propTypes = {
  centerPoint: PropTypes.object,
  setShowMap: PropTypes.func,
  showMap: PropTypes.bool,
};
